// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { BudgetEnforcementLevel } from "@insite/client-framework/Store/Pages/BudgetManagement/BudgetManagementReducer";
import {
    hasCustomerCarryOverUnusedMonthlyBalances,
    hasRoleWithAllowances,
} from "@store/Framework/Common/Utilities/customerUtilities";
import { useSession, useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";

const defaultBudgetRulesValues = {
    hasRoleWithAllowances: false,
    hasUserEnforcementLevel: false,
    budgetManagementEnabled: false,
    carryOverUnusedMonthlyBalances: false,
};

const useBudgetRules = () => {
    const session = useSession();
    const { extensionCustomerSettings } = useSettingsCollection();
    const billToState = useAppSelector(state => getCurrentBillToState(state));

    const isAuthenticated = session && session.isAuthenticated && !session.isGuest;

    if (!session || !isAuthenticated || !extensionCustomerSettings || !billToState.value) {
        return defaultBudgetRulesValues;
    }

    return {
        hasRoleWithAllowances: hasRoleWithAllowances(session.userRoles),
        hasUserEnforcementLevel: billToState.value?.budgetEnforcementLevel === BudgetEnforcementLevel.User,
        budgetManagementEnabled: extensionCustomerSettings.budgetManagementEnabled,
        carryOverUnusedMonthlyBalances:
            extensionCustomerSettings.carryOverUnusedMonthlyBalances &&
            hasCustomerCarryOverUnusedMonthlyBalances(session),
    };
};

export default useBudgetRules;
